export const DEFAULT_SPACING_BETWEEN_ELEMENTS = 3;
